import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import SerpTable from '../../../../components/muiLegacy/Tables/SerpTable';
import { VoxelPopover } from '../../../../components/voxel/Popover/VoxelPopover';
import { VoxelPopoverContent } from '../../../../components/voxel/Popover/VoxelPopoverContent';
import { VoxelPopoverTrigger } from '../../../../components/voxel/Popover/VoxelPopoverTrigger';
import { ProjectGq } from '../../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import { FrontendUserEventGq } from '../../../../graphql/users/queries/useFrontendLogUserEventGq';
import { usersApiService } from '../../../../graphql/users/usersApiService';
import { ProjectKeywordGq } from '../../../../graphql/projects/models/ProjectKeywordGq';

export interface SerpResultsPopoverProps {
  project: ProjectGq;
  keyword: ProjectKeywordGq;
  rank?: number;
  rankColor?: boolean;
}

export const SerpResultsPopover: React.FC<SerpResultsPopoverProps> = ({
  project,
  keyword,
  rank,
  rankColor,
}) => {
  const [openPopover, setOpenPopover] = useState(false);

  // Log user event
  const logUserEventMutation = usersApiService.mutations.useLogFrontendUserEvent();
  useEffect(() => {
    if (!openPopover) return;
    logUserEventMutation({
      event: FrontendUserEventGq.VISIT_PROJECT_SERP,
      projectId: project.id,
    });
  }, [project.id, openPopover]);

  // Get data
  const serpQuery = projectsApiService.queries.useGetKeywordSerpResults(
    { keywordId: keyword.id, projectId: project.id },
    { skip: !openPopover }
  );

  // Render
  if (!keyword) {
    return null;
  }

  return (
    <>
      <VoxelPopover
        enableArrow
        placement="bottom"
        offsetPx={14}
        onOpenChange={setOpenPopover}
        open={openPopover}
      >
        <VoxelPopoverTrigger enableActive>
          <div
            className={`
              w-8 px-0.5 rounded-[2px] text-[12px] font-medium 
              outline outline-1 outline-offset-1 outline-voxel-gray-200 hover:outline-voxel-gray-500  text-voxel-gray-700  
              ${openPopover ? 'outline-voxel-blue-400' : 'outline-transparent'}
              ${rankColor ? 'text-white outline-white hover:outline-white/75' : ''}
              `}
          >
            {rank ?? '100+'}
          </div>
        </VoxelPopoverTrigger>
        <VoxelPopoverContent paddingClass="p-6" className="">
          <div className="overflow-y-auto overscroll-y-contain max-h-[400px] ">
            {!serpQuery.result.length && <CircularProgress />}
            <SerpTable
              project={project}
              keyword={keyword}
              serpResult={serpQuery.result}
              rankNumber={rank}
            />
          </div>
        </VoxelPopoverContent>
      </VoxelPopover>
    </>
  );
};

export default SerpResultsPopover;
